export enum AuthMechanisms {
  OAUTH2 = 'oauth2',
  JWT = 'jwt',
}
